import React, { ComponentProps } from 'react';

import { Button } from '@zapier/design-system';
import { DropdownMenu } from '@zapier/common-components';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  chosenLabel: string;
  onChange: (value: SemVer) => void;
  size?: ComponentProps<typeof Button>['size'];
  version: SemVer;
  versions: SemVer[];
};

function VersionDropdown({
  chosenLabel,
  onChange,
  size,
  version,
  versions,
}: Props) {
  return (
    <DropdownMenu
      children={null}
      items={versions.map(v => ({ label: v, value: v }))}
      menuIsBlock={true}
      onSelect={({ value }) => onChange(value)}
      showDividers={true}
      ToggleComponent={toggleProps => (
        <Button iconBefore="arrowSmallDown" {...toggleProps} size={size}>
          {`${chosenLabel || 'Viewing'} ${version}`}
        </Button>
      )}
    />
  );
}

export default VersionDropdown;
